import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-job-detail',
  templateUrl: './page-job-detail.component.html',
  styleUrls: ['./page-job-detail.component.css']
})
export class PageJobDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
